import React from 'react';
import { useTranslation } from 'react-i18next';
import { Heading } from '@innovationnorway/cl-react';
import { GoalAccomplishmentDto } from 'src/api/v2';
import './GoalFeedback.scss';
import SivaGoalReview from './SivaGoalReview';
import ValueDifference from 'src/features/siva/components/ValueDifference/ValueDifference';

type Props = {
  clusterId: string;
  year: number;
  goal: GoalAccomplishmentDto;
  previousGoal?: GoalAccomplishmentDto;
  readMode?: boolean;
  setSivaHasSubmittedComment?: React.Dispatch<React.SetStateAction<boolean>>;
};

const GoalFeedback: React.FC<Props> = ({
  clusterId,
  year,
  goal,
  previousGoal,
  readMode,
  setSivaHasSubmittedComment,
}) => {
  const { t } = useTranslation('reportingNav');
  const { t: tCommon } = useTranslation();
  return (
    <div className="goal-feedback__card">
      <Heading level={3} className="goal-feedback-card__title">
        {goal.goalDetail.name}
      </Heading>

      <div className="display--flex align-items--center">
        <span className="margin-right--1">
          {goal?.expectedValue}
          {goal?.goalDetail.isPercentage ? '%' : ''}
        </span>
        <div className="display--flex align-items--center font-size--medium">
          <span>{'( '}</span>
          <ValueDifference
            value={goal.expectedValue}
            previousValue={previousGoal?.expectedValue ?? 0}
            isPercentage={goal?.goalDetail.isPercentage}
          />
          <span>{' )'}</span>
        </div>
      </div>

      {previousGoal !== undefined && (
        <div className="goal-feedback-card__previous-year">
          {t('goals.previousYearValue', { year: year - 1, value: previousGoal.expectedValue })}
        </div>
      )}
      {goal.clusterComment && (
        <div className="goal-feedback-card__comment">
          <label className="goal-feedback-card-comment__label" htmlFor={`${goal.id}_clusterComment`}>
            {tCommon('comment')}
          </label>
          <p className="goal-feedback-card-comment__text" id={`${goal.id}_clusterComment`}>
            {goal.clusterComment}
          </p>
        </div>
      )}
      <SivaGoalReview
        clusterId={clusterId}
        goal={goal}
        year={year}
        readMode={readMode}
        setSivaHasSubmittedComment={setSivaHasSubmittedComment}
      />
    </div>
  );
};

export default GoalFeedback;
